module.exports = __webpack_public_path__ + "static/img/13.9d08396.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/11/zh/13.png
// module id = KJKT
// module chunks = 0